import React, {useContext,useEffect,useState} from 'react'
// import { initMercadoPago } from '@mercadopago/sdk-react'
import Axios from 'axios';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Paper from '@mui/material/Paper';
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { formularioContext } from '../contextos/FormularioContext'
import Swal from 'sweetalert2';
import {Dialogos} from './Dialogos'
import {DatosPersonalesMinExterno} from './DatosPersonalesMinExterno'
import {useHelper} from '../hooks/useHelper'
import CircularProgress from '@mui/material/CircularProgress';
import Logo from './Logo';
import {Table, TableRow, TableCell, CardHeader,Alert} from '@mui/material'
import EventIcon from '@mui/icons-material/Event';
import LocationOnIcon from '@mui/icons-material/LocationOn';

export const NuevoEventosPorUsuario = ({esModoTest,dniministrotoken})=>{

    const { datos,
        handleChangeMinistroUad,
        descripcionProvincia,
        handleChangeDocumento,
        reinicializar,
        reinicializarConyuge,
        buscarDatosMinistro,
        handleChangeConyugeMinistroUad,
        datosMinistroOk,pedirDatosMinExterno,setPedirDatosMinExterno} = useContext(formularioContext)

        const [inscriptoPrincipalCargado,setInscriptoPrincipalCargado]= useState(false)
        const [datosMinistroUad,setDatosMinistroUad]= useState(null)
        const [pedirDatosConyuge,setPedirDatosConyuge] = useState(false)
        const [dniExternoCargado,setDniExternoCargado] = useState(false)
        const {scrollBottom}= useHelper()
        const [loading,setLoading]=useState(false);
        const [cantEventos,setCantEventos]=useState([]);
        const [hayEventosParaVisualizar,setHayEventosParaVisualizar]=useState(false);

   // initMercadoPago('APP_USR-8c9b233b-d2c0-44a2-b31e-e3863404a3b1');

    useEffect(()=>{
        const buscarCantidadEventos = async ()=>{
            try{
                const {data} = await Axios.get(process.env.NODE_ENV =='development' ? `http://localhost:3020/documentos/eventscant`:`https://uadapi.uad.digital/documentos/eventscant`)
                const eventosParaTest = data?.eventosParaTest || [];
                const eventosActivos = data?.eventosActivos || [];

                if(esModoTest){
                    setCantEventos(eventosParaTest)
                }else{
                    setCantEventos(eventosActivos)
                }
            }catch(err){
                setCantEventos([])
            }
        }
        buscarCantidadEventos();
        setTimeout(() => {
            if(dniministrotoken){
                validarDNI()
            }
        }, 500);
    },[])

    useEffect(()=>{
        setInscriptoPrincipalCargado(false)
        setPedirDatosMinExterno(false)
        if(datos?.ministroUad=='ministrouad'){
           setHayEventosParaVisualizar(cantEventos.some(i=>i?.exclusivo_uad==1))
        }else{
           setHayEventosParaVisualizar(cantEventos.some(i=>i?.exclusivo_uad==0))
        }

    },[datos.ministroUad])


    const cancelarBusquedaDatos = ()=>{
        setInscriptoPrincipalCargado(false)
        //setPedirDatosMinExterno(false)
        setDniExternoCargado(false)
        reinicializar()
    }

    const cancelarFormMinistroExterno = ()=>{
        setPedirDatosMinExterno(false)
    }

const validarDNI = ()=>{
    setLoading(true)
    buscarDatosMinistro() // sea ministro uad o no voy a verificar que el DNI está en la base de datos
    .then(info=>{
        if(!info){
            //handleChangeMinistroUad({target:{value:'externo'}})
            setLoading(false)
            setDniExternoCargado(true)
            //setPedirDatosMinExterno(true)
            //setInscriptoPrincipalCargado(true)
        }else{
            //handleChangeMinistroUad({target:{value:'ministrouad'}})
            setTimeout(() => {
                setDatosMinistroUad(info)
                setDniExternoCargado(false)
                setInscriptoPrincipalCargado(true) // Avanzar al próximo paso para validar datos como ministro uad
                setLoading(false)
                }, 2000);
        }
    })
    .catch(err=>{
        setLoading(false)
        Swal.fire({
            html:`<p>${err.message}</p>`,
            icon: 'warning',
            confirmButtonColor: '#3085d6',
        }) 
    })
}


const abrirFormConyuge = ()=>{
    setPedirDatosConyuge(true)
}

const abrirFormExterno = ()=>{
    setPedirDatosMinExterno(true)
}

const procesarMinistroExterno = ()=>{
    if(datosMinistroOk()[0]){
        setPedirDatosMinExterno(false)    
        setInscriptoPrincipalCargado(true)
    }else{
        Swal.fire({
            html:`<p>${datosMinistroOk()[1]}</p>`,
            icon: 'warning',
            customClass: 'slow-animation',
            confirmButtonColor: '#3085d6',
        })   
    }
}

const processHandleChangeDNI = (e)=>{
    handleChangeDocumento(e)
}

if(!datos.cant_max_personas){
    <Alert severity="info" variant='outlined'>
            El item seleccionado no tiene definida la cantidad de personas a inscribir
    </Alert>
} 

return <>
    <Grid
        container
        sx={{
            //minHeight: '100vh',
            flexDirection: { xs: 'column', md: 'column', lg: 'row' }, // ⬅️ apila hasta lg
        }}
        >
        {/* TEXTO */}
        <Grid
            item
            xs={12}
            lg={12}
            order={{ xs: 1, lg: 1 }} // se mantiene arriba siempre
            sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            px: { xs: 4, md: 10, lg: 20 },
            py: { xs: 6, md: 4 },
            textAlign: 'center',
            }}
        >
            {/* <Box>
            <Typography
                component="h1"
                sx={{
                color: 'white',
                fontWeight: 'bold',
                textShadow: '2px 2px 10px rgba(0,0,0,0.7)',
                fontSize: { xs: '2.8rem', sm: '3.6rem', md: '4.8rem' },
                }}
            >
                ¡Bienvenidos!
            </Typography>
            <Typography
                component="h2"
                sx={{
                color: 'white',
                fontWeight: 'bold',
                textShadow: '2px 2px 10px rgba(0,0,0,0.7)',
                lineHeight: 0.9,
                fontSize: { xs: '2.4rem', sm: '3rem', md: '4.3rem' },
                    mt: { xs: 2, md: -2 },
                }}
            >
                Tenemos un evento para vos...
            </Typography>
            </Box> */}

            <Box className='flex flex-col justify-center items-center'>
                <img
                        src={'/images/evento_default.jpeg'}
                        alt={'Tenemos un evento para vos!'}
                        className="w-full max-w-[300px] sm:max-w-[300px] md:max-w-[400px] lg:max-w-[500px]"
                        style={{ height: 'auto', objectFit: 'cover' }}
                />


                        <div className='px-10'>
                            <CardHeader
                                id="evento-inicio"
                                //subheader='Convención Nacional 2025'
                                //subheader='{eventoSeleccionado.subtitulo}'
                                titleTypographyProps={{ align: 'center', fontSize: 35 }}
                                subheaderTypographyProps={{ align: 'center', variant: 'h6', color: 'textSecondary' }}
                            />
                        </div>
                             <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'start',
                                    alignItems: 'start',
                                    flexDirection:'column',
                                }}
                            >
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    {/* <span className="material-icons" 
                                    style={{ marginRight: '8px', color: '#1976d2' }}>
                                        event
                                    </span> */}
                                    <EventIcon style={{ marginRight: '8px', color: '#1976d2' }} />
                                    <Typography variant="subtitle1" style={{ lineHeight: 1.2, fontWeight: 300,textAlign:'left' }}>4 al 6 de noviembre de 2025</Typography>
                                </div>
                                <br />
                                <div style={{ display: 'flex', alignItems: 'center'}}>
                                    {/* <span className="material-icons" style={{ marginRight: '8px', color: '#1976d2'}}>
                                        location_on
                                    </span> */}
                                    <LocationOnIcon style={{ marginRight: '8px', color: '#1976d2' }} />
                                    <Typography variant="subtitle1" style={{ lineHeight: 1.2, fontWeight: 300,textAlign:'left' }}><span style={{fontWeight:400}}> Auditorio Metropolitano</span><br></br>Ciudad de Rosario</Typography>
                                </div>
                            </div> 
            </Box>
 
        </Grid>
        {/* FORMULARIO */}
        <Grid
            item
            xs={12}
            lg={12}
            order={{ xs: 2, lg: 2 }} // se mantiene abajo siempre
            sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            px: { xs: 4, md: 6 },
            py: { xs: 4, md: 0 },
            }}
        >
            <Paper
            elevation={3}
            sx={{
                //p: 4,
                width: '100%',
                maxWidth: 500,
                borderRadius: '20px',
                //boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.6)',
                backgroundColor: 'white',
            }}
            >
            <>
              {!inscriptoPrincipalCargado && !dniExternoCargado && (
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    marginBottom: '3rem',
                  }}
                >
                  {/* <Logo width="120"/>  */}
                  <Typography variant="h6">
                    Próximanente se habilitarán las inscripciones
                  </Typography>

                  {datos.ministroUad && (
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                    {!loading && (
                        <Box
                            sx={{
                            marginTop: '1rem',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: '1rem',
                            width: '100%',
                            }}
                        >
                            <TextField
                            autoFocus
                            value={datos.documento}
                            onChange={(e) => processHandleChangeDNI(e)}
                            fullWidth
                            id="ub-dni"
                            inputProps={{ maxLength: 9, placeholder: 'DNI' }}
                            label="Ingrese su DNI"
                            variant="outlined"
                            />

                            {datos.documento && (
                                <Box sx={{ width: '100%' }}>
                                    <Button
                                    title="Continuar"
                                    disabled={
                                        datos.documento.trim() === '' || datos.documento.trim().length < 7
                                    }
                                    variant="contained"
                                    color="primary"
                                    sx={{
                                        width: '100%',
                                        backgroundColor: '#1976d2', // Azul relleno
                                        color: 'white',
                                        '&:hover': {
                                        backgroundColor: '#1565c0', // Azul más oscuro al pasar el mouse
                                        },
                                    }}
                                    onClick={validarDNI}
                                    >
                                    Continuar
                                    </Button>
                                </Box>
                                )}
                            </Box>
                        )}
                      {loading && (
                        <CircularProgress
                          sx={{
                            marginRight: 'auto',
                            marginLeft: 'auto',
                            display: 'block',
                            marginTop: '5px',
                          }}
                          color="primary"
                        />
                      )}
                    </Box>
                  )}
                </Box>
              )}

              {((inscriptoPrincipalCargado && datosMinistroOk()[0]) || datos.ministroUad=='externo') && (
                <Box>
                  <MostrarDatosMinistroCargado
                    datos={datos}
                    abrirFormConyuge={abrirFormConyuge}
                    abrirFormExterno={abrirFormExterno}
                    inscribir={() => {}}
                    datosConyugeOk={() => [true]}
                    reinicializarConyuge={reinicializarConyuge}
                    handleChangeConyugeMinistroUad={handleChangeConyugeMinistroUad}
                    descripcionProvincia={descripcionProvincia}
                    datosMinistroUad={datosMinistroUad}
                    cancelar={cancelarBusquedaDatos}
                    soloDni = {!datosMinistroOk()[0]}
                    dniministrotoken = {dniministrotoken}
                  />
                </Box>
              )}

              <FormularioMinistroExterno
                pedirDatosMinExterno={pedirDatosMinExterno}
                procesarMinistroExterno={procesarMinistroExterno}
                cancelarBusquedaDatos={cancelarFormMinistroExterno}
              />
            </>
          </Paper>
        </Grid>
      </Grid>
    </>
}

const MostrarDatosMinistroCargado = ({datos,
    datosMinistroUad,
    descripcionProvincia,
    abrirFormConyuge,
    abrirFormExterno,
    cancelar,soloDni,
    datosConyugeOk,dniministrotoken})=>{

if (datos.ministroUad=='ministrouad'){
    return <div>

        {/* <Typography style={{margin:'1.5rem',textAlign:'center'}} variant="h6">
            Estos son tus datos personales:       
        </Typography> */}
        <Grid container style={{justifyContent:'center'}}>
            <Grid item xs={12} sm="12" style={{display:'flex',flexDirection:'column',alignItems:'center'}}>
                <DatosMinistro datosMinistroUad={datosMinistroUad} texto=""/>
            </Grid> 
            <Box sx={{padding:'1rem',display:'flex',justifyContent:'space-evenly'}}>
                {!dniministrotoken && <Button onClick={cancelar} sx={{ textTransform: 'none' }} title='Cancelar la sesión y volver al inicio' variant='text'  color='primary'>Cancelar la sesión</Button>}
                   
                    {!datosConyugeOk()[0] && <Alert title={datosConyugeOk()[1]} variant="outlined" severity={'warning'}>
                        <Box sx={{display:'flex'}}>
                            <p>Requiere la inscripción del conyuge</p>
                            <Button color='primary' onClick={abrirFormConyuge}>Editar</Button>
                        </Box>
                    </Alert>
                } 
            </Box>
        </Grid>
        
    </div>
    }else{
    return <div>
        {/* <Typography style={{margin:'1.5rem',textAlign:'center'}} variant="h6">
            Estos son tus datos personales:
        </Typography> */}
        <Grid container style={{justifyContent:'center'}}>
            <Grid item xs={12} sm="12" style={{display:'flex',flexDirection:'column',alignItems:'center'}}>
                <Externo soloDni={soloDni} editar={abrirFormExterno} descripcionProvincia={descripcionProvincia} datos={{edad:datos.edad,nombre:datos.nombre,apellido:datos.apellido,sexo:datos.sexo,id_provincia:datos.id_provincia,documento:datos.documento,email:datos.email}} titulo=''/>
            </Grid> 
            <Box sx={{padding:'1rem',display:'flex',justifyContent:'space-evenly'}}>
                <Button onClick={cancelar} sx={{ textTransform: 'none' }} title='Cancelar la sesión y volver al inicio' variant='text'  color='primary'>Cancelar la sesión</Button>
                 
                    {!datosConyugeOk()[0] && <Alert title={datosConyugeOk()[1]} variant="outlined" severity={'warning'}>
                        <Box sx={{display:'flex'}}>
                            <p>Requiere la inscripción del conyuge</p>
                            <Button color='primary' onClick={abrirFormConyuge}>Editar</Button>
                        </Box>
                    </Alert>
                } 
            </Box>
        </Grid>
    </div>
}
}

const FormularioMinistroExterno = ({pedirDatosMinExterno,procesarMinistroExterno,cancelarBusquedaDatos})=>{
    return <Dialogos open={pedirDatosMinExterno} 
                        titulo='Ingresá tus datos personales' 
                        procesarResultado={procesarMinistroExterno}
                        procesarCancelar = {cancelarBusquedaDatos || false}
                       >
                  <DatosPersonalesMinExterno/>
    </Dialogos>
    }

    const DatosMinistro = ({ datosMinistroUad, editar, texto }) => {
    const [visualizar,setVisualizar] = React.useState(false)

        return (
            <div  style={{width:'300px'}}  className="border border-gray-300/50 rounded-lg p-4 w-full flex flex-col items-start">
                <div className="mb-4">
                    <h6 className="text-xl font-semibold text-center">{texto}</h6>
                </div>
                <div className="mb-2 relative">
                    <p className='text-left'>Sesión de:</p>
                    <p className="text-base font-medium text-left">{datosMinistroUad.nombre.toUpperCase()}</p>
                </div>
                <Button title={visualizar ? 'Ver más datos' : 'Ver menos datos'} onClick={()=>setVisualizar(!visualizar)}>
                        <span className="material-icons text-blue-600 mr-2">{visualizar ? 'expand_less' : 'expand_more'}</span>
                </Button>
                {visualizar && <div>
                    <div className="mb-2 border-b border-gray-300 pb-2 flex items-center">
                        <span className="material-icons text-blue-600 mr-2">badge</span>
                        <p className="text-base text-center">{datosMinistroUad.nro_documento}</p>
                    </div>
                    <div className="mb-2 border-b border-gray-300 pb-2 flex items-center">
                        <span className="material-icons text-blue-600 mr-2">cake</span>
                        <p className="text-base text-center">
                            {datosMinistroUad.edad !== '' ? `${datosMinistroUad.edad} años` : ''}
                        </p>
                    </div>
                    <div className="mb-2 border-b border-gray-300 pb-2 flex items-center">
                        <span className="material-icons text-blue-600 mr-2">place</span>
                        <p className="text-base text-center">{datosMinistroUad.provincia}</p>
                    </div>
                    <div className="pb-2 flex items-center">
                        <span className="material-icons text-blue-600 mr-2">email</span>
                        <p className="text-base text-center">{datosMinistroUad.email}</p>
                    </div>
                </div>}
            </div>
        );
    };

    const Externo = ({ datos, descripcionProvincia, soloDni, titulo }) => {
    const [visualizar,setVisualizar] = React.useState(false)

        if (soloDni){
            return( 
                <div style={{width:'300px'}} className="border border-gray-300/50 rounded-lg p-4 w-full flex flex-col items-start">
                <div className="mb-2 relative">
                    <p className='text-left'>Sesión de:</p>
                    <p className="text-base font-medium text-left"><span style={{color:'GrayText'}}>Número de documento: </span> {`${datos.documento}`}</p>
                </div>
            </div>)
        }

        return (
            <div style={{width:'300px'}} className="border border-gray-300/50 rounded-lg p-4 w-full flex flex-col items-start">
                <div className="mb-2 relative">
                    <p className='text-left'>Sesión de:</p>
                    <p className="text-base font-medium text-left">{`${datos.nombre} ${datos.apellido}`}</p>
                </div>
                <Button title={visualizar ? 'Ver más datos' : 'Ver menos datos'} onClick={()=>setVisualizar(!visualizar)}>
                        <span className="material-icons text-blue-600 mr-2">{visualizar ? 'expand_less' : 'expand_more'}</span>
                </Button>
                {visualizar && <div>
                    <div className="mb-2 border-b border-gray-300 pb-2 flex items-center">
                        <span className="material-icons text-blue-600 mr-2">badge</span>
                        <p className="text-base text-center">{datos.documento}</p>
                    </div>
                    <div className="mb-2 border-b border-gray-300 pb-2 flex items-center">
                        <span className="material-icons text-blue-600 mr-2">cake</span>
                        <p className="text-base text-center">
                            {datos.edad !== '' ? `${datos.edad} años` : ''}
                        </p>
                    </div>
                    <div className="mb-2 border-b border-gray-300 pb-2 flex items-center">
                        <span className="material-icons text-blue-600 mr-2">place</span>
                        <p className="text-base text-center">{descripcionProvincia(datos.id_provincia)}</p>
                    </div>
                    <div className="pb-2 flex items-center">
                        <span className="material-icons text-blue-600 mr-2">email</span>
                        <p className="text-base text-center">{datos.email}</p>
                    </div>
                </div>}
            </div>
        );
    };